export default __webpack_public_path__ + "static/media/320x320.0c34e1f3.jpg";